import FieldErrors from 'Components/FieldErrors'
import type { ErrorFields } from 'Components/FieldErrors/FieldErrors'
import type { SingleCodeCampaignDetailShape } from 'Services/SalesManagement/Features/Campaign/campaignSlice'
import { TextField } from '@mui/material'
import Box from '@mui/material/Box'
import type { FC, default as React } from 'react'
import { t } from 'ttag'

type CampaignDetailErrors = ErrorFields<SingleCodeCampaignDetailShape>

const SingleCodeCampaignDetails: FC<{
  campaignDetails: SingleCodeCampaignDetailShape
  fieldErrors: CampaignDetailErrors
  handleSetDetails: (
    value: string | number | string[] | Date,
    name: keyof SingleCodeCampaignDetailShape
  ) => void
}> = ({ campaignDetails, handleSetDetails, fieldErrors }) => {
  const handleDiscountCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target
    handleSetDetails(value, 'discount_code')
  }

  return (
    <Box>
      <TextField
        sx={{ minWidth: 300 }}
        required
        label={t`Discount code`}
        value={campaignDetails.discount_code}
        onChange={handleDiscountCodeChange}
        error={fieldErrors.discount_code?.length > 0}
        helperText={<FieldErrors error={fieldErrors.discount_code} identifier="discount_code" />}
      />
    </Box>
  )
}

export { SingleCodeCampaignDetails }
